import { api } from './client';

const STRAVA_CLIENT_ID = process.env.REACT_APP_STRAVA_CLIENT_ID;
const STRAVA_REDIRECT_URI = `${window.location.origin}/settings/strava-callback`;

export const stravaAPI = {
  getAuthUrl: () => {
    const params = new URLSearchParams({
      client_id: STRAVA_CLIENT_ID,
      redirect_uri: STRAVA_REDIRECT_URI,
      response_type: "code",
      scope: "activity:read_all",
      approval_prompt: "auto",
    });
    return `https://www.strava.com/oauth/authorize?${params.toString()}`;
  },
  connect: (code) => api.post('/strava/connect/', { code }),
  status: () => api.get('/strava/status/'),
  disconnect: () => api.post('/strava/disconnect/'),
  sync: (params = {}) => api.post('/strava/sync/', params),
};